import React, { useMemo } from 'react'
import { openUrl } from 'utils/utils'
import Icon from 'components/Icon/Icon'

import style from "./index.module.scss"

const ContactUs: React.FC = () => {
  return useMemo(() => (
    <div
     
      className={style.hint}
    >
      <div
        onClick={() =>
          openUrl(
            "https://www.transocks.com.cn/information.html?item=contact-us",
          )
        }
      >
      支付过程已全程加密，如遇任何问题可联系客服
        <Icon icon="iconicon_skip_" className={style.icon2} />
      </div> 
      <div>本产品不支持社交、支付、政府和违规网站。</div>
    </div>
  ), [])
}

export default ContactUs
